import {NavLink} from "react-router-dom";

function SideBarLinkDesign({icon, name, isCurrent}) {
    return <div
        className={`block truncate transition duration-150 ${
            isCurrent ? 'text-gray-800 dark:text-white' : 'text-gray-800 hover:text-violet-500 dark:text-white dark:hover:text-violet-400'
        }`}
    >
        <div className="ico-text flex items-center">
            <div className='icon w-5 text-center text-gray-400'>{icon}</div>
            <span
                className="text-sm font-medium ml-2 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
            >
                {name}
            </span>
        </div>
    </div>;
}

export default function SidebarLinkStandalone({route}) {
    let current = route['is_current'];

    if (route['name'] === null) {
        return <li></li>;
    }

    return <li
        className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${current && 'group-active standalone bg-[linear-gradient(135deg,var(--tw-gradient-stops))] from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]'}`}>
        {route['path'] && <NavLink end to={route['path']}>
            <SideBarLinkDesign name={route['name']} icon={route['icon']} isCurrent={current}/>
        </NavLink>}
        {route['href'] && <a  target={'_blank'} href={route['href']}>
            <SideBarLinkDesign name={route['name']} icon={route['icon']} isCurrent={current}/>
        </a>}
    </li>;
}